import { createApp } from "./app";

createApp();
